import React from "react"
import Image from "gatsby-image"

const HeadImage = ({fluid, className}) => (
  <Image fluid={fluid} className={`h-24 md:h-32 lg:h-40 w-full rounded-md ${className}`} />
)

export default HeadImage